/* Mavula Seats — Reserve page & Contact page JS */
(function () {
  'use strict';

  /* ── Stock data ── */
  var STOCK = {
    'hilux': {
      label: 'Toyota Hilux (2016-2024)',
      note: 'Manual Seat Models',
      img: document.querySelector('[data-img-hilux]') ? document.querySelector('[data-img-hilux]').dataset.imgHilux : '',
      ranges: {
        premium: {
          full:  { price: 1800, colourways: { charcoal: 5,  whiskey: 5  } },
          front: { price: 1099, colourways: { charcoal: 5,  whiskey: 5  } }
        },
        exclusive: {
          full:  { price: 1300, colourways: { charcoal: 10, whiskey: 10 } },
          front: { price: 799,  colourways: { charcoal: 10, whiskey: 10 } }
        }
      }
    },
    'lc79': {
      label: 'Toyota LandCruiser 79 Series',
      note: 'Manual Seat Models',
      img: document.querySelector('[data-img-lc79]') ? document.querySelector('[data-img-lc79]').dataset.imgLc79 : '',
      ranges: {
        premium: {
          full:  { price: 1800, colourways: { charcoal: 0, whiskey: 5  } },
          front: { price: 1099, colourways: { charcoal: 0, whiskey: 5  } }
        },
        exclusive: {
          full:  { price: 1300, colourways: { charcoal: 0, whiskey: 10 } },
          front: { price: 799,  colourways: { charcoal: 0, whiskey: 10 } }
        }
      }
    }
  };

  var COLOURWAY_LABELS = { charcoal: 'Charcoal Canvas - Dark Brown Leather', whiskey: 'Black Canvas - Whiskey Leather' };
  var RANGE_LABELS     = { premium: 'Premium Range', exclusive: 'Exclusive Range' };
  var PACKAGE_LABELS   = { full: 'Full Set', front: 'Front Package' };

  /* ── State ── */
  var state = { vehicle: 'hilux', range: 'premium', colour: 'charcoal', package: 'full' };

  /* ── Reserve page ── */
  var resPage = document.getElementById('reserve-page');
  if (resPage) initReservePage();

  function initReservePage() {
    var galleryImg = document.getElementById('res-gallery-img');
    var priceEl    = document.getElementById('res-price');
    var stockEl    = document.getElementById('res-stock');
    var reserveBtn = document.getElementById('reserve-btn');

    /* Chip selectors */
    document.querySelectorAll('[data-vehicle]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        state.vehicle = this.dataset.vehicle;
        state.colour  = 'charcoal';
        setActiveChips('[data-vehicle]', this);
        updateColourChips();
        updateDisplay();
      });
    });
    document.querySelectorAll('[data-range]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        state.range = this.dataset.range;
        setActiveChips('[data-range]', this);
        updateColourChips();
        updateDisplay();
      });
    });
    document.querySelectorAll('[data-package]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        state.package = this.dataset.package;
        setActiveChips('[data-package]', this);
        updateColourChips();
        updateDisplay();
      });
    });
    document.querySelectorAll('[data-colour]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (this.classList.contains('unavail')) return;
        state.colour = this.dataset.colour;
        setActiveChips('[data-colour]', this);
        updateDisplay();
      });
    });

    /* Accordion */
    document.querySelectorAll('.acc-trigger').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var body   = this.nextElementSibling;
        var isOpen = body.classList.contains('open');
        document.querySelectorAll('.acc-body').forEach(function (b) { b.classList.remove('open'); });
        document.querySelectorAll('.acc-trigger').forEach(function (t) { t.setAttribute('aria-expanded', 'false'); });
        if (!isOpen) {
          body.classList.add('open');
          this.setAttribute('aria-expanded', 'true');
        }
      });
    });

    updateColourChips();
    updateDisplay();

    function getPkg() {
      var v   = STOCK[state.vehicle];
      var rng = v ? v.ranges[state.range] : null;
      return rng ? rng[state.package] : null;
    }

    function getStock() {
      var pkg = getPkg();
      return pkg ? pkg.colourways[state.colour] : 0;
    }

    function updateDisplay() {
      var v   = STOCK[state.vehicle];
      var pkg = getPkg();
      var qty = getStock();

      /* gallery */
      if (galleryImg) {
        var key = 'img'
          + state.range.charAt(0).toUpperCase() + state.range.slice(1)
          + state.package.charAt(0).toUpperCase() + state.package.slice(1)
          + state.colour.charAt(0).toUpperCase() + state.colour.slice(1);
        var imgUrl = resPage.dataset[key];
        if (imgUrl) galleryImg.src = imgUrl;
      }

      /* price */
      if (priceEl && pkg) priceEl.textContent = '$' + pkg.price.toLocaleString();

      /* stock pill */
      if (stockEl) {
        stockEl.className = 'stock-pill';
        if (qty === 0) {
          stockEl.innerHTML = '<span class="dot"></span>Sold out';
          stockEl.classList.add('none');
        } else if (qty <= 5) {
          stockEl.innerHTML = '<span class="dot"></span>Only ' + qty + ' left';
          stockEl.classList.add('low');
        } else {
          stockEl.innerHTML = '<span class="dot"></span>Available';
          stockEl.classList.add('avail');
        }
      }

      /* reserve button */
      if (reserveBtn) {
        reserveBtn.disabled = qty === 0;
        if (qty === 0) reserveBtn.textContent = 'Sold Out';
      }

      updateFormBody(pkg);
    }

    function updateFormBody(pkg) {
      var bodyEl = document.getElementById('res-form-body');
      if (!bodyEl) return;
      var v        = STOCK[state.vehicle];
      var vLabel   = v ? v.label + (v.note ? ' — ' + v.note : '') : state.vehicle;
      var rLabel   = RANGE_LABELS[state.range]   || state.range;
      var pkgLabel = PACKAGE_LABELS[state.package] || state.package;
      var cLabel   = COLOURWAY_LABELS[state.colour] || state.colour;
      var price    = pkg ? '$' + pkg.price.toLocaleString() : '';
      bodyEl.value = [
        'RESERVATION REQUEST',
        '---',
        'Vehicle:   ' + vLabel,
        'Range:     ' + rLabel,
        'Package:   ' + pkgLabel,
        'Colourway: ' + cLabel,
        'Price:     ' + price
      ].join('\n');
    }

    function updateColourChips() {
      var rng = STOCK[state.vehicle] ? STOCK[state.vehicle].ranges[state.range] : null;
      var r   = rng ? rng[state.package] : null;
      document.querySelectorAll('[data-colour]').forEach(function (btn) {
        var c   = btn.dataset.colour;
        var qty = r ? r.colourways[c] : 0;
        btn.classList.toggle('unavail', qty === 0);
        if (qty === 0 && btn.classList.contains('active')) {
          var first = document.querySelector('[data-colour]:not(.unavail)');
          if (first) { state.colour = first.dataset.colour; setActiveChips('[data-colour]', first); }
        }
      });
    }

    function setActiveChips(selector, active) {
      document.querySelectorAll(selector).forEach(function (b) { b.classList.remove('active'); });
      active.classList.add('active');
    }
  }

  /* ── Contact page ── */
  var contactForm = document.getElementById('contact-form-wrap');
  if (contactForm) initContactPage();

  function initContactPage() {
    var vehicleFields = document.getElementById('vehicle-fields');

    document.querySelectorAll('.reason-chip').forEach(function (chip) {
      chip.addEventListener('click', function () {
        document.querySelectorAll('.reason-chip').forEach(function (c) { c.classList.remove('active'); });
        this.classList.add('active');
        var r = this.dataset.reason;
        if (vehicleFields) {
          var show = r === 'fitment' || r === 'reserve' || r === 'warranty';
          vehicleFields.classList.toggle('show', show);
        }
      });
    });

    document.querySelectorAll('.acc-trigger').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var body   = this.nextElementSibling;
        var isOpen = body.classList.contains('open');
        document.querySelectorAll('.acc-body').forEach(function (b) { b.classList.remove('open'); });
        document.querySelectorAll('.acc-trigger').forEach(function (t) { t.setAttribute('aria-expanded', 'false'); });
        if (!isOpen) { body.classList.add('open'); this.setAttribute('aria-expanded', 'true'); }
      });
    });
  }

})();
